



import HealthForceGoApp from '@/lib/HealthForceGoApp';
import { Component, Vue } from 'vue-property-decorator';
import * as Sentry from '@sentry/vue';

@Component
export default class InvalidBrowser extends Vue {
  mounted() {
    Sentry.captureMessage('Unsupported device accessed');
    this.$dialog.show({
      title: 'Your device may not be compatible to explore Newcross World.',
      buttons: [
        {
          label: 'Exit',
          handler: () => {
            HealthForceGoApp.dismiss();
          },
        },
        {
          label: 'Visit Site',
          handler: () => {
            HealthForceGoApp.openExternalURL(
              'https://learning.newcrosshealthcare.com'
            );
            HealthForceGoApp.dismiss();
          },
        },
      ],
    });
  }
}
